<tt-toast *ngIf="errorMessage" role="alert" ttType="danger" [ttTitle]="errorMessage" [ttTranslateTitle]="translateErrorMessage"></tt-toast>
<tt-toast *ngIf="statusMessage" role="status" ttType="success" [ttTitle]="statusMessage"></tt-toast>

<div class="ai-settings__panels">
    <tt-card class="ai-settings__card" ttHeading="ai_settings_create_provider" ttTranslateHeading ttIcon="far fa-plus">
        <tt-select
            ttLabel="ai_provider_name"
            ttLabelView="top"
            [(ttModel)]="page.ai_provider_id"
            [ttData]="providerNames"
            ttDataId="ai_provider_id"
            ttDataName="ai_provider_name"
            [ttDisabled]="busy"
        ></tt-select>
        <tt-input ttLabel="api_key_label" ttLabelView="top" [(ttModel)]="page.api_key_label" [ttDisabled]="busy"></tt-input>
        <tt-password-input ttLabel="api_key" ttLabelView="top" [(ttModel)]="page.api_key" [ttDisabled]="busy"></tt-password-input>
        <div class="ai-settings__actions">
            <tt-button
                ttText="ai_settings_create_provider"
                ttIcon="far fa-plus"
                ttIconAlign="left"
                (ttClick)="createProvider()"
                [ttLoading]="creating"
                [ttDisabled]="busy || !page.ai_provider_id || !page.api_key_label.trim() || !page.api_key.trim()"
            ></tt-button>
        </div>
    </tt-card>

    <tt-card class="ai-settings__card" ttHeading="ai_settings_existing_providers" ttTranslateHeading ttIcon="far fa-key">
        <tt-toast *ngIf="!loading && providers.length === 0" ttTitle="ai_settings_no_providers" ttType="warning"></tt-toast>
        <tt-list [ttData]="providers" ttDataId="ai_provider_keyno" ttDataName="ai_provider_name">
            <ng-template #ttListItemTemplate let-provider="item">
                <div class="ai-settings__provider">
                    <button
                        type="button"
                        class="ai-settings__provider-button"
                        [disabled]="busy"
                        [attr.aria-expanded]="page.ai_provider_keyno === provider.ai_provider_keyno"
                        [attr.aria-controls]="'ai-provider-editor-' + provider.ai_provider_keyno"
                        (click)="selectProvider(provider)"
                    >
                        <span class="ai-settings__provider-label">
                            <span class="ai-settings__provider-name">{{ provider.ai_provider_name }}</span>
                            <span class="ai-settings__provider-key-label">{{ provider.api_key_label }}</span>
                        </span>
                        <span [ngClass]="page.ai_provider_keyno === provider.ai_provider_keyno ? 'far fa-chevron-up' : 'far fa-chevron-down'" aria-hidden="true"></span>
                    </button>

                    <div *ngIf="page.ai_provider_keyno === provider.ai_provider_keyno" class="ai-settings__provider-editor" [id]="'ai-provider-editor-' + provider.ai_provider_keyno">
                        <tt-input ttLabel="ai_provider_id" ttLabelView="top" [ttModel]="provider.ai_provider_id" ttReadonly></tt-input>
                        <tt-input ttLabel="api_key_label" ttLabelView="top" [ttModel]="provider.api_key_label" ttReadonly></tt-input>
                        <tt-password-input ttLabel="ai_settings_new_api_key" ttLabelView="top" [(ttModel)]="replacementApiKey" [ttDisabled]="busy"></tt-password-input>
                        <div class="ai-settings__actions">
                            <tt-button
                                ttText="ai_settings_replace_api_key"
                                ttIcon="far fa-key"
                                ttIconAlign="left"
                                (ttClick)="replaceApiKey(provider)"
                                [ttLoading]="replacing"
                                [ttDisabled]="busy || !replacementApiKey.trim()"
                            ></tt-button>
                            <tt-button
                                ttText="ai_settings_delete_provider"
                                ttIcon="far fa-trash-alt"
                                ttIconAlign="left"
                                ttType="ghost-danger"
                                (ttClick)="deleteProvider(provider)"
                                [ttLoading]="deleting"
                                [ttDisabled]="busy"
                            ></tt-button>
                        </div>
                    </div>
                </div>
            </ng-template>
        </tt-list>
    </tt-card>
</div>
